import React, { useState } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../config/api';
import { copyText } from '../utils/copyText';

const newPin = () => String(Math.floor(100000 + Math.random() * 900000));

// Student logins for the teacher's class: login ID, 1-tap temporary PIN, and "View as Student".
function TeacherStudentAccess({ students, onViewAsStudent }) {
  const [pins, setPins] = useState({}); // { studentId: pin } shown after a reset
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState({ ok: true, text: '' });

  const reset = async (s) => {
    if (!window.confirm(`Reset password for ${s.name}? Their current password will stop working.`)) return;
    const pin = newPin();
    setBusy(s._id);
    setMsg({ ok: true, text: '' });
    try {
      await axios.put(`${API_BASE_URL}/api/users/${s._id}`, { password: pin });
      setPins((p) => ({ ...p, [s._id]: pin }));
    } catch (e) {
      setMsg({ ok: false, text: e?.response?.data?.message || 'Could not reset the password. Try again.' });
    } finally {
      setBusy('');
    }
  };

  const copy = async (text) => {
    const ok = await copyText(text);
    setMsg(ok ? { ok: true, text: 'Copied ✓' } : { ok: false, text: 'Copy failed. Select and copy manually.' });
  };

  const sorted = [...students].sort((a, b) => (a.name || '').localeCompare(b.name || ''));

  return (
    <section className="th-card">
      <div className="th-card-head"><h2>Student Logins</h2><span className="th-muted">{students.length} students</span></div>
      <p className="th-muted th-hint">Share the temporary PIN with the student, then ask them to change it from their Profile.</p>
      {msg.text && <div className={msg.ok ? 'th-okmsg' : 'th-error'}>{msg.text}</div>}
      {sorted.length === 0 ? (
        <p className="th-empty">No students in this class.</p>
      ) : (
        <ul className="th-list">
          {sorted.map((s, i) => (
            <li key={s._id} className="th-acc">
              <div className="th-row-title">{s.rollNo || s.rollNumber ? `${s.rollNo || s.rollNumber}. ` : `${i + 1}. `}{s.name}</div>
              <div className="th-muted th-wrap">Login ID: {s.email || '—'}</div>
              {pins[s._id] && (
                <div className="th-pin">
                  <span>New PIN: <b>{pins[s._id]}</b></span>
                  <button className="th-link" onClick={() => copy(pins[s._id])}>Copy</button>
                </div>
              )}
              <div className="th-actions">
                <button className="th-btn th-btn-sm th-btn-outline" disabled={busy === s._id} onClick={() => reset(s)}>
                  {busy === s._id ? 'Resetting…' : '🔑 Reset PIN'}
                </button>
                <button className="th-btn th-btn-sm" onClick={() => onViewAsStudent(s)}>👁️ View as Student</button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}

export default TeacherStudentAccess;
